import React, {useState} from "react";
import {Action, Button, ButtonSize, ButtonStyle, FlexContent, FlexContentAlignment, FlexContentDirection, FlexContentSpacing, Icon, ModalContent, ModalNew, Paragraph, ParagraphAlignment, TranslationLibFile} from "@sirdata/ui-lib";
import {AdBlockDetectedWrapper} from "adblock-detect-react";
import {useTranslation} from "react-i18next";
import {TranslationPortalFile} from "../../utils/constants";

const ModalAdBlockDetector: React.FC = () => {
    const {t: textCommon} = useTranslation(TranslationLibFile.COMMON);
    const {t} = useTranslation(TranslationPortalFile.TRANSLATION);
    const [active, setActive] = useState(true);

    const handleClose = () => setActive(false);

    return (
        <AdBlockDetectedWrapper>
            <ModalNew onClose={handleClose} active={active} cssClass="modal-adblock-detector">
                <ModalContent>
                    <FlexContent direction={FlexContentDirection.COLUMN} alignment={FlexContentAlignment.CENTER} spacing={FlexContentSpacing.SMALL}>
                        <Icon name="warning" outlined cssClass="modal-adblock-detector__icon"/>
                        <span className="modal-adblock-detector__title">
                            {t("modal.ad_blocker.title")}
                        </span>
                        <Paragraph alignment={ParagraphAlignment.CENTER}>
                            {t("modal.ad_blocker.content")}
                        </Paragraph>
                        <Button size={ButtonSize.BIG} style={ButtonStyle.PRIMARY_MIDNIGHT} onClick={handleClose}>
                            {textCommon(Action.CLOSE.labelKey)}
                        </Button>
                    </FlexContent>
                </ModalContent>
            </ModalNew>
        </AdBlockDetectedWrapper>
    );
};

export default ModalAdBlockDetector;
